import axios from 'axios';

axios.defaults.timeout = process.env?.VUE_APP_AXIOS_TIMEOUT_MS || 0;
axios.defaults.headers.common['X-TacLite-AppToken'] =
    process.env.VUE_APP_TACLITE_APPTOKEN_VALUE;

export default axios;
